export default __webpack_public_path__ + "static/media/escanor.d3fbe070.png";